import getWalkInAvailabilitySlotStatus, {
  type WalkInSlotAvailabilityProperties,
} from "./getWalkInAvailabilitySlotStatus";
import type { Prettify } from "../../../types";

type AvailableWalkInSlot = Prettify<
  Omit<WalkInSlotAvailabilityProperties, "open" | "available" | "time"> & {
    open: true;
    available: true;
    time: string;
  }
>;

/**
 * Walk-in counterpart of `isSlotAvailable`: uses {@link walkInDinersAvailable}
 * and claim windows. Removable with `model/walkIn`.
 */
export default function isWalkInSlotAvailable(
  slot: WalkInSlotAvailabilityProperties,
  people?: number | null,
): slot is AvailableWalkInSlot {
  return getWalkInAvailabilitySlotStatus(slot, people) === "available";
}
